import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { cartUrlFromCategory, HAIRCARE_CART_URL } from 'constants/cart';

import consultationCategoryProp from 'PropTypes/consultationProps';

import GoToDecider from '../Scenes/GoToDecider';

import { getHasSubscriptionFromCategory, getHaveOrders } from 'dux/user/selectors';

const GoToDeciderContainer = ({ consultationCategory, hasSubscription, hasOrder }) => (
  <GoToDecider
    cartUrl={cartUrlFromCategory[consultationCategory] || HAIRCARE_CART_URL}
    hasOrder={hasOrder}
    hasSubscription={hasSubscription}
  />
);

GoToDeciderContainer.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  hasSubscription: PropTypes.bool.isRequired,
  hasOrder: PropTypes.bool.isRequired,
};

export default connect((state, consultationCategory) => ({
  hasSubscription: getHasSubscriptionFromCategory(state, { consultationCategory }),
  hasOrder: getHaveOrders(state),
}))(GoToDeciderContainer);
